<template>
  <DoctorImage :image="data.image" :name="data.title" />

  <div>
    <DoctorRating :reviews="[{ rating: 5 }]" />

    <h5 class="text-left text-black text-[1.2rem] sm:text-[1.2rem] font-bold">
      {{ data.title }} <br />
      <span
        class="text-black text-[1.0rem] font-normal"
        v-safe-html="data.smallText"
      >
      </span>
    </h5>

    <span
      class="text-left font-manrope font-medium leading-tight max-w-sm sm:text-[1.6rem] md:text-[1.6rem]"
      v-safe-html="data.text"
    ></span>
  </div>
</template>

<script lang="ts">
import DoctorImage from "@/components/doctor/doctorImage.vue";
import DoctorRating from "@/components/doctor/doctorRating.vue";
import type { Testimonial } from "@/services/testimonialService";
import { PropType } from "vue";

export default {
  name: "TestimonialComponent",
  components: {
    DoctorImage,
    DoctorRating,
  },
  props: {
    data: {
      type: Object as PropType<Testimonial>,
      required: true,
    },
  },
};
</script>

<style scoped>
.rating_text {
  font-family: Manrope;
}
</style>
